module.exports = __webpack_public_path__ + "static/media/iconEditOrange.3dfaaf61.svg";